import React from "react";
import "./postcode-container.scss";
import { Postcode } from "./Postcode";

interface PostcodeContainerProps {
  className?: string;
  isRequiredField?: boolean;
  onChange: Function;
  value?: string;
}

interface PostcodeContainerState {
  postcode: string;
}

export class PostcodeContainer extends React.Component<PostcodeContainerProps, PostcodeContainerState> {
  static defaultProps = {
    isRequiredField: true,
    value: null
  };
  private postcodeRef: Postcode | null;

  constructor(props: PostcodeContainerProps) {
    super(props);
    this.state = {
      postcode: props.value || ""
    };
    this._onPostcodeChange = this._onPostcodeChange.bind(this);
  }

  componentDidUpdate(prevProps: PostcodeContainerProps, prevState: PostcodeContainerState) {
    if (prevProps.value !== this.props.value) {
      const postcode = this.props.value || "";
      if (this.postcodeRef) {
        this.postcodeRef.setState({ value: postcode });
      }
      this.setState({
        postcode
      });
    }
  }

  render() {
    return (
      <div className="c-postcode-container">
        <Postcode
          ref={ref => (this.postcodeRef = ref)}
          className={this.props.className}
          isRequiredField={this.props.isRequiredField}
          onChange={this._onPostcodeChange}
          initialValue={this.state.postcode}
        />
      </div>
    );
  }

  _onPostcodeChange(postcode: string) {
    this.setState({ postcode });
    this._callOnChangeHandler(postcode);
  }

  _callOnChangeHandler(postcode: string) {
    if (this.props.onChange) {
      this.props.onChange({ postcode });
    }
  }
}
